import axios from 'axios'

function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

function getCorrectColor($value) {
    switch ($value) {
        case "Passief":
            return '#f7d1d0';
        case "Afspraak":
            return '#dcebd8';
        case "In contact":
            return '#f7f0c5';
        case "Teruggestuurd RSCA":
            return '#e1d8ed';
        case "Send":
            return '#f7f0c5';
        case "Not Send":
            return '#f7d1d0';
        case "Private Loges":
            return '#e1d8ed';
        case "Indoor Business seats":
            return '#cfc2e0';
        case "Open Business Seats":
            return '#dcebd8';
        case "Step Up Pack":
            return '#bfe4b5';
        case "Step Up Pack + Catering":
            return '#afdea2';
        case "All-In Pack":
            return '#f7f0c5';
        case "Sponsoring":
            return '#b3c1af';
        case "Events en/of Vergaderen":
            return '#ffd5c2';
        case "Afspraak in het Lotto Park":
            return "#d1f3ec";
        case "M.F. Confirmation send":
            return "#d2e4eb";
        case "E.S. Confirmation send":
            return "#94b2bd";
        case "M.F. Rondleiding afgerond - Opmaak voorstel":
            return "#f7f0c5";
        case "E.S. Rondleiding afgerond - Opmaak voorstel":
            return "#bfb88b";
        case "Voorstel goedgekeurd":
            return "#dcebd8";
        default:
            return getRandomColor();
    }
}

//Default values
const state = {
    convFromActive: null,
    convFromPassive: null,
    leadSourceDistribution: null,
    salesFunnel: null,
    projectFunnel: null,
    statusDistribution: null,
    packetDistribution: null,
    projectDistribution: null,
    vipDistribution: null,
    watchDistribution: null,
    salesDistribution: null,
    seatsDistribution: null,
    totalSeats: null,
    infobrochure: null,
    totalCalls: null,
    proposals: null,
    form: {
        countries: ["AM"],
        sources: [],
        sales_modular: '',
        sales: '',
        date: '',
        chart: '',
        chart_item: '',
    },
    modal: {
        show: false,
        chart_title: ''
    }
}

//Mutations voor de data voor de chart in de goede vorm te zetten
const mutations = {
    'GET_CHART_CONV_FROM_ACTIVE'(state, serverdata) {
        let labels = (serverdata.length == 0) ? ['No results'] : Object.keys(serverdata);
        let values = [];
        let colors = [];
        for (var key in serverdata) {
            values.push(serverdata[key]);
            colors.push(getCorrectColor(key));
        }
        state.convFromActive = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['#828282'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'conv-from-active'
        }
    },
    'GET_CHART_CONV_FROM_PASSIVE'(state, serverdata) {
        let labels = (serverdata.length == 0) ? ['No results'] : Object.keys(serverdata);
        let values = [];
        let colors = [];
        for (var key in serverdata) {
            values.push(serverdata[key]);
            colors.push(getCorrectColor(key));
        }
        state.convFromPassive = {
            labels: labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['#828282'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'conv-from-passive'
        }
    },
    'GET_LEAD_SOURCE_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = []
        for (var key in serverdata) {
            if (serverdata[key].lead_status == null) {
                labels.push('Not assigned')
            } else {
                labels.push(serverdata[key].lead_status)
            }

            values.push(serverdata[key].total)
            colors.push(getCorrectColor(serverdata[key].lead_status));
        }

        state.leadSourceDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['#666666'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'lead-status-distribution'
        }
    },
    'GET_INFOBROCHURE'(state, serverdata) {
        let labels = []
        let values = []
        let colors = []
        for (var key in serverdata) {
            labels.push(serverdata[key].infobrochure)
            values.push(serverdata[key].total)
            colors.push(getCorrectColor(serverdata[key].infobrochure));
        }

        state.infobrochure = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['#666666'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'infobrochure-in-contact-distribution'
        }
    },
    'GET_SALES_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = []
        for (var key in serverdata) {
            labels.push(serverdata[key].sales_person)
            values.push(serverdata[key].total)
            colors.push(getRandomColor())
        }

        state.salesDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['#666666'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'sales-distribution'
        }
    },
    'GET_SEATS_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = []
        for (var key in serverdata) {
            labels.push(serverdata[key].seats_in_season)
            values.push(serverdata[key].total)
            colors.push(getRandomColor())
        }

        state.seatsDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['#666666'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'seats-in-season-distribution'
        }
    },
    'GET_TOTAL_SEATS'(state, serverdata) {
        state.totalSeats = {
            total: serverdata
        }
    },
    'GET_STATUS_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].status)
            values.push(serverdata[key].total)
            switch (serverdata[key].status) {
                case "Active":
                    colors.push('orange')
                    break;
                case "Hold":
                    colors.push('gray')
                    break;
                case "Passive":
                    colors.push('brown')
                    break;
                case "Project":
                    colors.push('lightgreen')
                    break;
                default:
                    colors.push(getRandomColor())
                    break;

            }
        }

        state.statusDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'lead-status-distribution'
        }
    },
    'GET_PACKET_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].which_packet)
            values.push(serverdata[key].total)
            colors.push(getCorrectColor(serverdata[key].which_packet));

        }

        state.packetDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'packet-distribution'
        }
    },
    'GET_PROJECT_STAGE_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].project_stage)
            values.push(serverdata[key].total)
            colors.push(getCorrectColor(serverdata[key].project_stage));
        }

        state.projectDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'project-stage-distribution'
        }
    },
    'GET_PROPOSALS'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].proposal)
            values.push(serverdata[key].total)
            colors.push(getCorrectColor(serverdata[key].proposal));

        }

        state.proposals = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'proposals'
        }
    },
    'GET_PROJECT_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].project_stage)
            values.push(serverdata[key].total)
            colors.push(getCorrectColor(serverdata[key].project_stage));
        }

        state.projectDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_VIP_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].has_vip)
            values.push(serverdata[key].total)
            colors.push(getRandomColor())
        }

        state.vipDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_WATCH_DISTRIBUTION'(state, serverdata) {
        let labels = []
        let values = []
        let colors = [];

        for (var key in serverdata) {
            labels.push(serverdata[key].where_to_watch)
            values.push(serverdata[key].total)
            colors.push(getRandomColor())
        }

        state.watchDistribution = {
            labels: (serverdata.length == 0) ? ['No results'] : labels,
            datasets: [
                {
                    backgroundColor: (serverdata.length == 0) ? ['empty'] : colors,
                    data: (serverdata.length == 0) ? [100] : values,
                    hoverBorderWidth: 8,
                }
            ]
        }
    },
    'GET_SALES_FUNNEL'(state, serverdata) {
        let labels = []
        let values = []

        for (var key in serverdata) {
            labels.push(key)
            values.push(Math.round(serverdata[key]))
        }
        state.salesFunnel = {
            labels: labels,
            datasets: [
                {
                    backgroundColor: ['#f7f0c5', '#c1efb5', '#dcebd8'],
                    data: values,
                    hoverBorderWidth: 8,
                }
            ],
            listName: 'sales-funnel'
        }
    },
    'GET_PROJECT_FUNNEL'(state, serverdata) {
        let labels = []
        let values = []

        let datasets = []

        for (let key in serverdata) {
            labels.push(key)
            let serverDateInside = serverdata[key]
            let dataSetArr = []
            for (let key2 in serverDateInside) {
                dataSetArr.push(serverDateInside[key2].avg)
            }
            let tempColor = getCorrectColor(key);
            datasets.push({
                label: key,
                data: dataSetArr,
                fill: false,
                borderColor: tempColor, // Add custom color border (Line)
                backgroundColor: tempColor, // Add custom color border (Line)
                borderWidth: 3, // Specify bar border width
                type: 'line'
            })
        }


        state.projectFunnel = {
            labels: labels,
            datasets: datasets,
            // labels: ["Afspraak", "Voorstel", "M.F. conf", "E.S. Conf", "M.F. rond", "E.S. Rond"],
            // datasets: [
            //     {
            //         label: 'Afspraak in het lotto park', // Name the series
            //         data: [0, 0.5, 3.35, 3.85, 1, 0, 0], // Specify the data values array
            //         fill: false,
            //         borderColor: '#2196f3', // Add custom color border (Line)
            //         backgroundColor: '#2196f3', // Add custom color background (Points and Fill)
            //         borderWidth: 1 // Specify bar border width
            //     },
            //     {
            //         label: 'E.S. confirmation send', // Name the series
            //         data: [0, 0, 0, 0, 0, 0, 2.99], // Specify the data values array
            //         fill: false,
            //         borderColor: '#e92e25', // Add custom color border (Line)
            //         backgroundColor: '#e92e25', // Add custom color background (Points and Fill)
            //         borderWidth: 1 // Specify bar border width
            //     },
            //     {
            //         label: 'M.F. confirmation send', // Name the series
            //         data: [1.5, 0, 15.75, 2, 0, 0, 0], // Specify the data values array
            //         fill: false,
            //         borderColor: '#6521fb', // Add custom color border (Line)
            //         backgroundColor: '#6521fb', // Add custom color background (Points and Fill)
            //         borderWidth: 1 // Specify bar border width
            //     },
            //     {
            //         label: 'E.S. confirmation send', // Name the series
            //         data: [0, 0, 0, 0, 0, 15, 0], // Specify the data values array
            //         fill: false,
            //         borderColor: '#d49c17', // Add custom color border (Line)
            //         backgroundColor: '#d49c17', // Add custom color background (Points and Fill)
            //         borderWidth: 1 // Specify bar border width
            //     },
            //     {
            //         label: 'M.F. rondleiding', // Name the series
            //         data: [0, 0, 0, 0, 0, 7, 0], // Specify the data values array
            //         fill: false,
            //         borderColor: '#ed388a', // Add custom color border (Line)
            //         backgroundColor: '#ed388a', // Add custom color background (Points and Fill)
            //         borderWidth: 1 // Specify bar border width
            //     },
            //     {
            //         label: 'E.S. rondleiding', // Name the series
            //         data: [0, 0, 0, 0, 0, 0, 0], // Specify the data values array
            //         fill: false,
            //         borderColor: '#475fae', // Add custom color border (Line)
            //         backgroundColor: '#475fae', // Add custom color background (Points and Fill)
            //         borderWidth: 1 // Specify bar border width
            //     }],
            listName: 'project-stage-funnel'
        }

        // state.projectFunnel = {
        //     labels: labels,
        //     datasets: [
        //         {
        //             backgroundColor: ['orange', 'darkgreen', 'lightgreen'],
        //             data: values,
        //             hoverBorderWidth: 8,
        //         }
        //     ],
        //     listName: 'project-stage-funnel'
        // }
    },
    'GET_TOTAL_CALLS'(state, serverdata) {
        state.totalCalls = {
            total: serverdata.data['total-calls'],
            appointments: serverdata.data['total-appointments']
        }
    },
    'GET_CHART_MODAL'(state, data) {
        state.modal.show = true
        state.modal.chart_title = data.chart_title
    },
    'CLOSE_CHART_MODAL'(state) {
        state.modal.show = false
        state.form.chart = ''
        state.form.chart_item = ''
    },
    'GET_CHART_MODAL_DATA'(state, data) {
        state.form.chart = data.chart
        state.form.chart_item = data.chart_item
    }
}

//Data van de API ophalen en daarna mutations oproepen om deze data in de goede vorm te gieten
const actions = {
    CALL_CHART_DATA: async (context, payload) => {
        //Format sources for return to api
        let sources = []
        for (var key in payload.sources) {
            sources.push(payload.sources[key].name)
        }

        return axios.post(process.env.VUE_APP_API_URL + 'items/data', {
            apps: payload.countries,
            sources: sources,
            sales: payload.sales_modular,
            start_date: (payload.date) ? payload.date.start : '',
            end_date: (payload.date) ? payload.date.end : '',
            sales_modular: (payload.sales_modular.length == 0) ? '' : payload.sales_modular
        })
            .then((res) => {
                let workspace = payload.countries[0]
                //Alle standaard data ophalen

                //Specifieke chart data ophalen
                if (workspace === 'AM') {
                    context.commit('GET_CHART_CONV_FROM_ACTIVE', res.data['conv-from-active']);
                    context.commit('GET_CHART_CONV_FROM_PASSIVE', res.data['conv-from-passive'])
                    context.commit('GET_SALES_FUNNEL', res.data['sales-funnel'])
                    context.commit('GET_INFOBROCHURE', res.data['infobrochure-in-contact-distribution'])
                    context.commit('GET_LEAD_SOURCE_DISTRIBUTION', res.data['lead-status-distribution'])
                    context.commit('GET_TOTAL_CALLS', res)
                } else if (workspace === 'CLIENTS') {
                    context.commit('GET_CHART_CONV_FROM_ACTIVE', res.data['conv-from-active']);
                    context.commit('GET_CHART_CONV_FROM_PASSIVE', res.data['conv-from-passive'])
                    context.commit('GET_PROJECT_FUNNEL', res.data['project-stage-funnel'])
                    context.commit('GET_PACKET_DISTRIBUTION', res.data['packet-distribution'])
                    context.commit('GET_PROJECT_STAGE_DISTRIBUTION', res.data['project-stage-distribution'])
                    context.commit('GET_PROPOSALS', res.data['proposals'])
                } else if (workspace === '2019/20') {
                    context.commit('GET_LEAD_SOURCE_DISTRIBUTION', res.data['lead-status-distribution'])
                    // context.commit('GET_WATCH_DISTRIBUTION', res.data['where-to-watch-distribution'])
                    context.commit('GET_SALES_FUNNEL', res.data['sales-funnel'])
                    context.commit('GET_PACKET_DISTRIBUTION', res.data['packet-distribution'])

                    context.commit('GET_SALES_DISTRIBUTION', res.data['sales-distribution'])
                    context.commit('GET_SEATS_DISTRIBUTION', res.data['seats-in-season-distribution'])
                    context.commit('GET_TOTAL_SEATS', res.data['total-seats'])
                    // context.commit('GET_STATUS_DISTRIBUTION', res.data['status-distribution'])
                    // context.commit('GET_PROJECT_STAGE_DISTRIBUTION', res.data['project-stage-distribution'])
                    // context.commit('GET_PROPOSALS', res.data['proposals'])
                }


                // context.commit('GET_VIP_DISTRIBUTION', res.data['vip-distribution'])
            })
    },
    CALL_CHART_MODAL_DATA: async (context, payload) => {
        context.commit('GET_CHART_MODAL', payload)
        context.commit('GET_CHART_MODAL_DATA', payload)
    },
    CLOSE_CHART_MODAL: async (context, payload) => {
        context.commit('CLOSE_CHART_MODAL')
        context.commit('TABLE_RESET')
    },
}

//Getters voor eenvoudig de data op te vragen in de components
const getters = {
    CHART_CONV_FROM_ACTIVE: state => {
        return state.convFromActive;
    },
    CHART_CONV_FROM_PASSIVE: state => {
        return state.convFromPassive;
    },
    CHART_LEAD_SOURCE_DISTRIBUTION: state => {
        return state.leadSourceDistribution;
    },
    CHART_SALES_FUNNEL: state => {
        return state.salesFunnel;
    },
    CHART_PROJECT_FUNNEL: state => {
        return state.projectFunnel;
    },
    CHART_STATUS_DISTRIBUTION: state => {
        return state.statusDistribution;
    },
    CHART_SALES_DISTRIBUTION: state => {
        return state.salesDistribution;
    },
    CHART_SEATS_DISTRIBUTION: state => {
        return state.seatsDistribution;
    },
    CHART_PACKET_DISTRIBUTION: state => {
        return state.packetDistribution;
    },
    CHART_PROJECT_DISTRIBUTION: state => {
        return state.projectDistribution;
    },
    CHART_PROPOSALS: state => {
        return state.proposals;
    },
    CHART_VIP_DISTRIBUTION: state => {
        return state.vipDistribution;
    },
    CHART_WATCH_DISTRIBUTION: state => {
        return state.watchDistribution;
    },
    CHART_TOTAL_CALLS: state => {
        return state.totalCalls;
    },
    CHART_TOTAL_SEATS: state => {
        return state.totalSeats;
    },
    CHART_MODAL: state => {
        return state.modal;
    },
    CHART_FORM: state => {
        return state.form;
    },
    CHART_INFOBROCHURE: state => {
        return state.infobrochure;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
